angular
  .module('ui-ng-sibling')
  .controller('siblingMediatorController', function ($scope) {
    var mediation = {};

    this.onMessage = function onMessage(channelName, $scope, fn) {
      mediation[channelName] = mediation[channelName] || [];
      mediation[channelName].push({
        $scope: $scope,
        fn: fn
      });
    };

    this.siblingMessage = function siblingMessage(channelName, $scope, value) {
      _.each(mediation[channelName], function (sibling) {
        if (sibling.$scope.$id !== $scope.$id) {
          sibling.fn.call(sibling.$scope, value);
        }
      });
    };

    this.siblingBroadcast = function siblingBroadcast(channelName, $scope, value) {
      _.each(mediation[channelName], function (sibling) {
        sibling.fn.call(sibling.$scope, value);
      });
    };

    $scope.$on('$destroy', function () {
      mediation = undefined;
    });
  })
  .directive('siblingMediator', function () {
    return {
      scope: false,
      restrict: 'EA',
      controller: 'siblingMediatorController'
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-sibling/src/lib/mediator.js